import styled from 'styled-components';

import { IncentivesGrid as StyledIncentivesGrid } from './loyalty-incentives.styled.base';

export * from './loyalty-incentives.styled.base';

export const IncentivesGrid = styled(StyledIncentivesGrid)<{
  incentiveSelected: boolean;
  isWidget: boolean;
  isCarousel: boolean;
}>`
  ${Styles.desktop`
    width: 100%;
    ${(p: any) =>
      p.isCarousel ? 'height: 100%;' : 'height: calc(100vh - 149px - env(safe-area-inset-bottom))'}
  `}
`;
